export default __webpack_public_path__ + "static/media/gbemileke.f86b9c42.png";